import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

interface OrderCardProps {
  sx?: SxProps<Theme>;
}

export default function OrderCard({
  children,
  sx,
}: React.PropsWithChildren<OrderCardProps>) {
  return (
    <Box
      sx={[
        (theme) => ({
          // In dark mode the card sits a step above the page on the elevation ramp
          // (surfaceOverlay vs the surface base) so it reads as clearly raised — a
          // plain drop shadow barely registers on the near-black base. Light mode
          // keeps the shipped white raised surface.
          bgcolor:
            theme.palette.mode === 'dark'
              ? theme.semantic.surfaceOverlay
              : theme.semantic.surfaceRaised,
          border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
          borderRadius: theme.spacing(),
          // Dark: a faint light top-edge highlight + soft ambient shadow convey lift
          // (a black drop shadow is invisible on the dark base). Light: shipped shadow.
          boxShadow:
            theme.palette.mode === 'dark'
              ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.06), 0 2px 8px 0 rgba(0, 0, 0, 0.55)'
              : '0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
          width: '100%',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
